import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { httpService } from "../../httpService";
import { Button, CircularProgress, Typography } from "@mui/material";

export default function ExamserversBreakdown() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [examination, setExamination] = useState(null);
  const [centres, setCentres] = useState([]);

  const getData = async () => {
    setLoading(true);
    const { data } = await httpService.get(
      `servermanager/examServerList/${id}`
    );

    if (data) {
      setExamination(data.examination);
      setCentres(data.result);
      //setReport(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);
  const navigate = useNavigate();
  return (
    <div>
      Exam servers breakdown
      <div className="mt-4 mb-4">
        {loading && <CircularProgress />}
        {examination && (
          <div>
            <div className="mb-3 col-lg-6 ">
              <Typography variant="h5" gutterBottom textTransform={"uppercase"}>
                {examination.title}
              </Typography>
              <Typography color="GrayText">exam servers and centres</Typography>
            </div>

            <Table striped bordered>
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Server ID</th>
                  <th>State</th>
                  <th>Centre Name</th>
                  <th>Candidates</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {centres.map((c, i) => (
                  <tr>
                    <td>{i + 1}</td>
                    <td>
                      <Typography>{c.centreId}</Typography>
                    </td>
                    <td>
                      <Typography>{c.state}</Typography>
                    </td>
                    <td className="col-lg-6">
                      <Typography>{c.name}</Typography>
                    </td>
                    <td>{c.assignedCandidates}</td>
                    <td>
                      <Button
                        onClick={() =>
                          navigate(
                            `/serversmanager/centrescandidates?centre=${c._id}&examination=${examination._id}`
                          )
                        }
                      >
                        view
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th>S/N</th>
                  <th>Server ID</th>
                  <th>State</th>
                  <th>Centre Name</th>
                  <th>Candidates</th>
                  <th>View</th>
                </tr>
              </tfoot>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
}
